module.exports = __webpack_public_path__ + "media/images/flags/lk-2b5b63422cba6d2ae8c907cb0aac325c.svg";